/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Recovery_WheelInputs */



/**
* | output |
* | --- |
* | "Recovery wheel" |
*
* @param {Air_Handler_Unit_Recovery_WheelInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_recovery_wheel = /** @type {((inputs?: Air_Handler_Unit_Recovery_WheelInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Recovery_WheelInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Recovery wheel")
	return /** @type {LocalizedString} */ ("Roue de récupération")
});